export type VariationSelectionField = "color" | "gauge" | "length";

export const updateVariationSelection = (
  variation: Variation,
  field: VariationSelectionField,
  value: string
): Variation => {
  if (field === "color") {
    return {
      ...variation,
      color: value.toLowerCase(),
      gauge: "",
      length: "",
    };
  }

  return { ...variation, [field]: value };
};
